import React, { useEffect } from "react";
import {
  // Breadcrumbs, Chip, Tooltip, Button,
  Container, Box
} from '@mui/material';
// import { styled } from '@mui/material/styles';
// import Link from 'next/link';
// import { useRouter } from 'next/router';
import { dataConstants } from '../../src/constants';
// import PropTypes from 'prop-types';
import Summary from "../../src/components/Economy/Summary";
import chart from "../../src/api/decorators/chart/chart";
// import { getChartTheme } from "../../lib/charts/_getThemes";
import { withProtected } from "../../src/hook/route";
import getEcoTabData from "../../lib/economy/_getEcoTabData";
import getPageMetaTags from "../../lib/meta/_getMetaTags";
import getChartTheme from "../../lib/charts/_getThemes";
import EconomyToolbar from "../../src/components/_common/EconomyToolbar";
// import onPageInit from "../../src/actions/onPageInit";

const { ECO_TABS, ECO_TABS_CODES } = dataConstants || {};

const baseValue = {};

const settings = (baseline = baseValue, payload = {}) => ({
  ...baseline,
  ...payload,
});


const getTheme = (baseline = baseValue, payload = {}) => {
  const { type, chart_settings, series_settings = {}, icon } = payload || {};

  const { pallete, gradient } = payload.pallete ? JSON.parse(payload.pallete) : {};

  return {
    type,
    chartSettings: settings(undefined, JSON.parse(chart_settings)),
    pallete,
    gradient,
    seriesSettings: JSON.parse(series_settings),
    icon,
  };
};

const getSeries = (baseline = baseValue, payload = {}) => {
  const { c, r, v } = payload || {};
  return {
    code: c,
    value: v,
    recordDate: r,
  };
};

const ecoTabs = payload => {
  const { getEcoTabData } = payload || {};

  let keyMap = { c: 'code', v: 'value', r: 'recordDate' };
  const getTabData = d => {
    switch (d.type) {
      case dataConstants.STOCK_SECTION_TYPES.CHART:
        return d.tabData && d.tabData.length > 0 ? chart(undefined, d.tabData[0]).getChart : undefined;
      case dataConstants.STOCK_SECTION_TYPES.TICKER_TABLE:
        return d.tabData && d.tabData.length > 0 ? convertTickerTblFromData({ ...d.tabData[0], tickers: d.tabData[0].tickers ? JSON.parse(d.tabData[0].tickers) : d.tabData[0].tickers }) : undefined;
      case dataConstants.STOCK_SECTION_TYPES.TABLE_DATA:
        const tabData = d.tabData && d.tabData.length > 0 ? convertTblFromData(d.tabData) : undefined;
        return tabData;
      case "SERIES":
        // return d?.tabData && d?.tabData?.length > 0 ? d?.tabData?.map(d => getSeries(undefined, d)) : undefined;
        return d?.tabData && d?.tabData?.length > 0 ? d?.tabData?.map((obj) => {
          return Object.keys(obj).reduce((acc, key) => {
            if (keyMap[key]) {
              acc[keyMap[key]] = obj[key];
            } else {
              acc[key] = obj[key];
            }
            return acc;
          }, {})
        }) : undefined;
      default:
        return d.tabData;
    }
  }

  return {
    getEcoTabData: getEcoTabData && getEcoTabData.length && getEcoTabData.map(d => ({
      ...d,
      tabData: getTabData(d),
      settings: d.settings ? JSON.parse(d.settings) : d.settings,
    })),
  };
}

const AtAGlance = (props) => {
  // const { asPath } = useRouter();
  const { eco_tab_data, chart_theme, toggleColorMode, themeMode, isPremium, openDialog } = props || {}
  const { getEcoTabData } = ecoTabs(eco_tab_data) || {}
  const { getThemes } = chart_theme || {};
  // const router = useRouter();
  // const [tabData, setTabData] = React.useState(getEcoTabData);
  const [value, setValue] = React.useState(0);
  const [themes, setThemes] = React.useState(getThemes && getThemes.map(d => getTheme(undefined, d)))

  // const [alert, setAlert] = React.useState(false);
  const [selectedInfo, setSelectedInfo] = React.useState(null);
  // const tickerTab = asPath && /[^/]*$/.exec(asPath)[0];
  // const [clipboard, setClipboard] = React.useState(null);
  // const [mounted, setMounted] = React.useState(false)

  // if (!mounted) {
  //   onPageInit(asPath);
  // }

  // useEffect(() => {
  //   setMounted(true)
  // }, [])

  // const handleClipboard = (value) => {
  //   const el = document.createElement('textarea');
  //   el.value = value;
  //   document.body.appendChild(el);
  //   el.select();
  //   document.execCommand('copy');
  //   document.body.removeChild(el);

  //   setClipboard("Copied");

  //   setTimeout(() => {
  //     setClipboard(null);
  //   }, 3000);
  // };

  const handleChange = (event, newValue) => {
    // setValue(newValue);
    // event.preventDefault();
  };
  // const handleAlert = () => {
  //   setAlert(!alert);
  // };

  // const getChartData = (ch, data, prop = 'series_data') => {
  //   const c = chart(undefined, ch).getChart;
  //   return {
  //     ...c,
  //     [prop]: data,
  //     currTheme: themes.find(d => d.type === JSON.parse(c.chartSetting).themeName),
  //     chartSetting: JSON.parse(c.chartSetting),
  //   };
  // }
  const getChartData = (ch, data, prop = 'series_data') => {
    // const c = chart(undefined, ch).getChart;
    return {
      ...ch,
      [prop]: data,
      // currTheme: themes.find(d => d.type === JSON.parse(c.chartSetting).themeName),
      currTheme: themes.find(d => d.type === ch.chartSetting.themeName),
    };
  }

  const onChangeInfo = selected_Info => {
    setSelectedInfo(selectedInfo !== selected_Info ? selected_Info : null);
  }

  return (
    <>
      {/* // <Layout toggleColorMode={toggleColorMode} themeMode={themeMode}> */}
      <Box sx={{ flexGrow: 1 }}>
        <EconomyToolbar
          themeMode={themeMode}
          value={value}
          handleChange={handleChange}
          tabName={"Summary"}
        />
      </Box>
      <Container maxWidth="lg">
        <Box component="div" className="us-economy-summary-wrapper" sx={{ pt: 0 }}>
          <Summary
            data={getEcoTabData}
            themes={themes}
            getChartData={getChartData}
            selectedInfo={selectedInfo}
            onChangeInfo={infoItem => onChangeInfo(infoItem)}
            isPremium={isPremium}
            openDialog={openDialog}
          />
        </Box>
      </Container>
      {/* // </Layout> */}
    </>
  );
}

export async function getStaticProps({ params, tabCode = "GLANCE", preview = false }) {
  // GLANCE: "GLANCE",
  //   HOUSING: "HOUSING",
  //     GDP: "GDP",
  //       CONSUMER: "CONSUMER",
  //         YIELD: "YIELD"

  const eco_tab_data = (await getEcoTabData(tabCode, undefined)) || [];
  const chart_theme = (await getChartTheme({ type: "Default" })) || []
  const meta_tags = (await getPageMetaTags(`/us-economy`, false)) || {}
  const { getMetaTags } = meta_tags || {}
  return {
    props: {
      eco_tab_data,
      chart_theme,
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.DEFAULT_HOURS,
  }
}


export default withProtected(AtAGlance);
